<div class="column footer-container edit-toggle-page">
	@if (device) {
		<div class="content-container">
			<div class="content-container-header flex-row-end">
				<h3 class="flex-grow" i18n="@@deviceAbout-deviceDetails">Device Details</h3>
				@if (
					canEditDevices &&
					(isPDQ || displayUninstallFlagForSentriVault) &&
					activeCompanyId === editDevice.companyId &&
					device.activeDeviceAssignment?.activeInstallation?.installationLocation
				) {
					<div class="uninstall-button flex-fixed">
						<button
							id="uninstallLockBtn"
							i18n="@@device-detailUninstallLockButton"
							class="removal-small-button button-wider-and-taller button-width-125px"
							(click)="onUninstallLockClicked()"
							[disabled]="isEditingSettings"
							data-automation-id="device-uninstall-lock-button"
						>
							Uninstall
						</button>
					</div>
				}
				@if (
					canEditDevices &&
					isEditing === false &&
					(activeCompanyId === editDevice.companyId ||
						(canEditInheritedDevice() &&
							!deviceIsExpired &&
							device.activeDeviceAssignment?.activeInstallation?.installationLocation))
				) {
					<div class="spacing-24 flex-fixed">
						<button
							i18n="@@device-detailEditButton"
							class="primary-small-button button-wider-and-taller"
							(click)="onEditClicked()"
							[disabled]="isEditingSettings || isEditing"
							data-automation-id="device-about-edit-button"
						>
							Edit
						</button>
					</div>
				}
				@if (isEditing) {
					<div class="spacing-8 flex-fixed flex-row">
						<div class="flex-1">
							<button
								i18n="@@device-detailCancel"
								class="secondary-small-button button-wider-and-taller"
								(click)="onCancelEditClicked()"
								data-automation-id="device-about-cancel-button"
							>
								Cancel
							</button>
						</div>
						@if (canEditDevices && !isPDQ) {
							@if (
								!editDevice.readyForRemoval &&
								editDevice.status === 'inService' &&
								activeCompanyId === editDevice.companyId &&
								!displayUninstallFlagForSentriVault
							) {
								<div class="flex-1">
									<button
										class="removal-small-button button-wider-and-taller button-width-175px"
										(click)="readyForRemovalClicked()"
										i18n="@@deviceAbout-ReadyForRemoval"
										data-automation-id="ready-for-removal-button"
									>
										Ready for Removal
									</button>
								</div>
							}
							@if (editDevice.readyForRemoval && activeCompanyId === editDevice.companyId) {
								<div class="flex-1">
									<button
										class="removal-small-button button-wider-and-taller button-width-175px"
										(click)="clearRemovalStatusClicked()"
										i18n="@@deviceAbout-ClearRemovalStatus"
										data-automation-id="clear-removal-status-button"
									>
										Clear Removal Status
									</button>
								</div>
							}
						}
						<div class="flex-1">
							<button
								i18n="@@device-detailSaveChanges"
								class="primary-small-button button-wider-and-taller button-width-125px"
								(click)="onSaveDeviceDetailChangesClicked()"
								[disabled]="isSaveDeviceDetailsDisabled()"
								data-automation-id="device-about-save-changes-button"
							>
								Save Changes
							</button>
						</div>
					</div>
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				<!-- nothing is editable on a device -->
				@if (isEditing && isInstallPhotoManagementFeatureEnabled) {
					<div class="row">
						<div class="warning-message">
							<mat-icon svgIcon="sl-alert"></mat-icon>
							<p data-automation-id="device-about-edit-warning-banner">
								<span class="highlighted-text">{{ deviceDetailsEditWarningHeader }}</span>
								{{ deviceDetailsEditWarningBody }}
							</p>
						</div>
					</div>
				}
				<div class="row">
					<div class="flex-5">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey" i18n="@@device-detailStatus">Status</td>
									<td class="width-25-grey" i18n="@@device-detailSerialNumber">Serial Number</td>
									<td class="width-25-grey" i18n="@@device-detailCartonNumber">Carton Number</td>
									<td class="width-25-grey" i18n="@@device-detailPalletNumber">Pallet Number</td>
								</tr>
								<tr class="mat-body-3">
									<td>
										<app-device-status
											[device]="device"
											[installation]="device.activeDeviceAssignment?.activeInstallation"
										></app-device-status>
									</td>
									<td class="table-body-text">{{ device.serialNumber }}</td>
									<td class="table-body-text">{{ device.cartonNumber }}</td>
									<td class="table-body-text">{{ device.palletNumber }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey" i18n="@@device-detailPropertyName">Property Name</td>
									<td class="width-25-grey" data-automation-id="device-detail-location-name">
										{{ deviceLocationName }}
										@if (isLocationNameEditable()) {
											<span class="required-asterisk-symbol">*</span>
										}
									</td>
									<td class="width-25-grey" i18n="@@device-detailDeviceType">Type of Device</td>
									<td class="width-25-grey" i18n="@@device-detailDateArrived">Date Arrived</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">
										{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
									</td>
									<td class="table-body-text">
										@if (!isLocationNameEditable()) {
											@if (hasValidInstallationLocation()) {
												{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}
											}
										}
										@if (isLocationNameEditable()) {
											<mat-form-field
												subscriptSizing="dynamic"
												class="column margin-right-20 infix-width-auto"
												appearance="outline"
												[class.mat-form-field-invalid]="shouldShowLocationNameValidation()"
											>
												<input
													matInput
													[(ngModel)]="editDevice.locationName"
													(blur)="onLocationNameBlur()"
													data-automation-id="location-name-input"
													required
												/>
											</mat-form-field>
										}
									</td>
									<td class="table-body-text">{{ device.deviceType }}</td>
									<td class="table-body-text">{{ device.utcDateArrived | utcToLocal }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey" i18n="@@device-detailAddress">Address</td>
									<td class="width-25-grey" i18n="@@device-detailLatitude">Latitude</td>
									<td class="width-25-grey" i18n="@@device-detailLongitude">Longitude</td>
									<td class="width-25">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text" [innerHtml]="deviceAddress | address"></td>
									<td class="table-body-text">
										{{
											device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
												?.geoCoordinates?.latitude
										}}
									</td>
									<td class="table-body-text">
										{{
											device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
												?.geoCoordinates?.longitude
										}}
									</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey">
										@if (installationPhotoError) {
											<div class="installation-photo-error" role="alert" data-automation-id="installation-photo-error">
												<mat-icon svgIcon="sl-alert" class="installation-photo-error-icon"></mat-icon>
												{{ installationPhotoError }}
											</div>
										}
									</td>
									<td class="width-25-grey">
										@if (canManageInstallationPhoto() && shouldShowInstallationPhotoCaption()) {
											<ng-container data-automation-id="photo-caption-header" i18n="@@device-detailPhotoCaption"
												>Photo Caption</ng-container
											>
										}
									</td>
									<td class="width-25">&nbsp;</td>
									<td class="width-25">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">
										<input
											#installationPhotoInput
											type="file"
											class="installation-photo-file-input"
											accept=".jpg,.jpeg,.png,image/jpeg,image/png"
											[disabled]="!isEditing || !canManageInstallationPhoto()"
											(change)="onInstallationPhotoSelected($event)"
											data-automation-id="installation-photo-file-input"
										/>
										@if (shouldShowImageUploadPlaceholder()) {
											<button
												type="button"
												class="device-installation-photo-placeholder"
												(click)="installationPhotoInput.click()"
												[disabled]="isPreparingInstallationPhoto || isSavingDeviceDetails"
												data-automation-id="installation-photo-placeholder"
											>
												<mat-icon class="device-installation-photo-upload-icon" svgIcon="sl-upload-item"></mat-icon>
												<span class="device-installation-photo-upload-text" i18n="@@deviceAbout-imageUpload"
													>Image Upload</span
												>
											</button>
										}
										@if (!isInstallationPhotoDeletePending) {
											<div class="device-installation-photo-gallery-with-button">
												<div class="device-installation-photo-gallery spacing-16">
													@if (selectedInstallationPhotoPreviewUrl) {
														<div class="device-installation-photo-hover-container">
															<img
																class="device-installation-photo-item"
																[src]="selectedInstallationPhotoPreviewUrl"
																alt="Selected installation photo preview"
																i18n-alt="@@deviceAbout-selectedInstallPhotoPreview"
																data-automation-id="installation-photo-preview"
															/>
														</div>
													} @else {
														@for (it of deviceInstallationPhotos; track it.id) {
															<div class="device-installation-photo-hover-container">
																<img
																	class="device-installation-photo-item"
																	[src]="it.photoUrl"
																	alt="device installation photo"
																	(click)="showPhotoGallery()"
																	data-automation-id="show-photo-gallery-img"
																/>
															</div>
														}
													}
												</div>
												@if (isEditing && shouldShowInstallationPhotoSection() && canEditInstallationPhotoCaption()) {
													<div class="device-installation-photo-hover-container">
														<div class="button-container">
															<button
																type="button"
																class="replace-photo-button"
																(click)="installationPhotoInput.click()"
																i18n="@@deviceAbout-replacePhoto"
																data-automation-id="replace-installation-photo-button"
															>
																<mat-icon class="replace-photo-icon" svgIcon="sl-image"></mat-icon>
																Replace
															</button>
															<button
																type="button"
																class="delete-photo-button"
																(click)="onDeleteInstallationPhotoClicked()"
																i18n="@@deviceAbout-deletePhoto"
																data-automation-id="delete-installation-photo-button"
															>
																<mat-icon class="delete-photo-icon" svgIcon="sl-dismiss"></mat-icon>
																Delete
															</button>
														</div>
													</div>
												}
											</div>
										}
										@if (isPreparingInstallationPhoto) {
											<div class="installation-photo-status" aria-live="polite" i18n="@@deviceAbout-preparingPhoto">
												Preparing image…
											</div>
										}
									</td>
									<td class="table-body-text">
										@if (isEditing && canEditInstallationPhotoCaption()) {
											<div class="device-installation-photo-edit-fields">
												<mat-form-field subscriptSizing="dynamic" appearance="outline" class="photo-caption-field">
													<input
														matInput
														[(ngModel)]="editInstallationPhotoCaption"
														placeholder="Photo Caption"
														i18n-placeholder="@@deviceAbout-photoCaptionPlaceholder"
														data-automation-id="installation-photo-caption-input"
													/>
												</mat-form-field>
											</div>
										} @else if (canManageInstallationPhoto() && editInstallationPhotoCaption) {
											<div class="device-installation-photo-edit-fields">
												<span data-automation-id="photo-caption-value">{{ editInstallationPhotoCaption }}</span>
											</div>
										}
									</td>
									<td></td>
									<td></td>
								</tr>
							</table>
						</div>
					</div>
					<div class="flex-1">
						<div class="flex-column">
							@if (deviceMarker[0]?.position) {
								<app-map [mapCenter]="mapCenter" [markers]="deviceMarker"></app-map>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	}

	<p>&nbsp;</p>

	<div class="row additional-device-info-container">
		@if (!deviceIsExpired && device) {
			<div class="content-container column width-50">
				<div class="content-container-header flex-row-space-between">
					<h3 i18n="@@device-detailOwner">Owner</h3>
					@if (hasTransferDeviceInventoryOwnershipCapability) {
						<div>
							<button
								i18n="@@device-detailTransferOwnershipButton"
								class="primary-small-button button-wider-and-taller"
								(click)="transferOwnershipClicked()"
								[disabled]="isEditing || isEditingSettings"
								data-automation-id="device-about-edit-two-button"
							>
								Edit
							</button>
						</div>
					}
				</div>
				<mat-divider></mat-divider>
				<div class="content-container-body row spacing-24">
					<div class="row spacing-24 owner-name-container">
						<div style="float: left">
							<mat-icon svgIcon="sl-nav-work" class="circle-icon device-owner-icon"></mat-icon>
						</div>
						<div class="device-owner-name">{{ ownerName }}</div>
					</div>
				</div>
			</div>
		}

		@if (
			!deviceIsExpired &&
			(device.keyDetectionAvailable ||
				device.ajaxEnabled ||
				(isPDQ && device.activeDeviceAssignment?.activeInstallation?.installationLocation))
		) {
			<div class="content-container column width-50">
				<div class="content-container-header flex-row-space-between">
					<h3 class="flex-1" i18n="@@deviceAbout-deviceSettings">Device Settings</h3>
					<!--
          The user must be in the owning company and have editing device capabilities in order to edit.
          Additionally, if they are editing a PDQ device they must have editable device capabilities, mainly "ajaxEnabled".
          -->
					@if (
						canEditDevices &&
						(activeCompanyId === editDevice.companyId || isOracle || (canEditInheritedDevice() && !deviceIsExpired)) &&
						isEditingSettings === false &&
						(!isPDQ || device.ajaxEnabled)
					) {
						<div>
							<button
								i18n="@@device-detailEditSettingsButton"
								class="primary-small-button button-wider-and-taller"
								(click)="onEditSettingsClicked()"
								[disabled]="isEditing"
								data-automation-id="edit-button"
							>
								Edit
							</button>
						</div>
					}
					@if (isEditingSettings) {
						<div class="flex-row-end">
							<div class="flex-1">
								<button
									i18n="@@device-detailCancel"
									class="secondary-small-button button-wider-and-taller"
									(click)="onCancelEditSettingsClicked()"
									data-automation-id="device-about-cancel-two-button"
								>
									Cancel
								</button>
							</div>
							<div class="flex-1">
								<button
									[disabled]="!!device.ajaxEnabled && !ajaxHubIdFormControl.valid"
									i18n="@@device-detailSaveChanges"
									class="primary-small-button button-wider-and-taller button-width-125px"
									(click)="onSaveSettingsClicked()"
									data-automation-id="device-about-save-changes-two-button"
								>
									Save Changes
								</button>
							</div>
						</div>
					}
				</div>
				<mat-divider></mat-divider>
				@if (!isPDQ) {
					<div class="content-container-body column spacing-24">
						@if (device.keyDetectionAvailable) {
							<div class="row">
								<div class="column">
									<p i18n="@@deviceAbout-companySettingsKeyDetection">Key Detection</p>
								</div>
								<div class="column device-settings-flex-end">
									@if (isEditingSettings) {
										<mat-slide-toggle
											[disabled]="!isEditingSettings"
											[(ngModel)]="editDevice.keyDetection"
											data-automation-id="key-detection-toggle"
										></mat-slide-toggle>
									}
									@if (!isEditingSettings) {
										@if (editDevice.keyDetection) {
											<span i18n="@@deviceAbout-keyDetectionOn" class="device-settings-text">On</span>
										}
										@if (!editDevice.keyDetection) {
											<span i18n="@@deviceAbout-keyDetectionOff" class="device-settings-text">Off</span>
										}
									}
								</div>
							</div>
						}
						@if (!!device.ajaxEnabled) {
							<div class="row">
								<div class="column center-elements-vertically">
									<p i18n="@@deviceAbout-companySettingsAJAXHubId">AJAX Hub ID</p>
								</div>
								<div class="column device-settings-flex-end">
									@if (isEditingSettings) {
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="form-field-input-no-margin">
											<input
												matInput
												#input
												[formControl]="ajaxHubIdFormControl"
												data-automation-id="ajax-hub-id-input"
											/>
											@if (this.ajaxHubIdFormControl.hasError('limitedAlphanumeric')) {
												<mat-error
													class="row-left"
													data-automation-id="ajax-hub-id-code-error"
													i18n="@@deviceAbout-errorMessageLettersAndNumbers"
												>
													Letters (A-F) and numbers only.
												</mat-error>
											}
										</mat-form-field>
									}
									@if (!isEditingSettings && finishedInitDeviceSettingsKVLoading) {
										<ng-container class="column center-elements-vertically">
											<p>
												{{
													isInvalidString(this.deviceSettingsKV.ajaxHubId) ? '- - -' : this.deviceSettingsKV.ajaxHubId
												}}
											</p>
										</ng-container>
									}
								</div>
							</div>
						}
					</div>
				}
				@if (isPDQ) {
					<div class="device-settings-pdq-container">
						@if (device.activeDeviceAssignment?.activeInstallation?.installationLocation) {
							<div class="device-setting-margin-bottom">
								<div class="row">
									<div class="column">
										<p i18n="@@deviceAbout-lockPosition">Lock Position</p>
									</div>
									<div class="column device-settings-flex-end">
										@if (deviceSettingsKV.handedness) {
											<div class="device-settings-handedness-value">
												@if (deviceSettingsKV.handedness === 'right') {
													<span i18n="@@deviceAbout-lockPositionRightHanded" class="device-settings-text"
														>Right-handed</span
													>
												}
												@if (deviceSettingsKV.handedness !== 'right') {
													<span i18n="@@deviceAbout-lockPositionLeftHanded" class="device-settings-text"
														>Left-handed</span
													>
												}
											</div>
										}
									</div>
								</div>
							</div>
						}
						@if (device.activeDeviceAssignment?.activeInstallation?.installationLocation) {
							<div>
								<div class="row">
									<div class="column">
										<p i18n="@@deviceAbout-relockSettings">Re-lock Settings</p>
									</div>
									<div class="column device-settings-flex-end">
										<div>
											@if (deviceSettingsKV.autoRelockDelay) {
												<span class="device-settings-text" class="device-settings-relock-value">
													@if (deviceSettingsKV.autoRelockDelay === '-1') {
														<span i18n="@@deviceAbout-manualRelock">Manual Re-lock</span>
													}
													@if (deviceSettingsKV.autoRelockDelay !== '-1') {
														<span
															><span i18n="@@deviceAbout-autoRelock" class="device-settings-text">Auto Re-lock</span
															><span> - {{ deviceSettingsKV.autoRelockDelay }}</span
															><span i18n="@@deviceAbout-seconds">s</span></span
														>
													}
												</span>
											}
										</div>
									</div>
								</div>
							</div>
						}
						@if (!!device.ajaxEnabled) {
							<div
								class="row"
								[ngClass]="{
									'padding-top-small': device.activeDeviceAssignment?.activeInstallation?.installationLocation,
								}"
							>
								<div class="column center-elements-vertically">
									<p i18n="@@deviceAbout-companySettingsAJAXHubId">AJAX Hub ID</p>
								</div>
								<div class="column device-settings-flex-end">
									@if (isEditingSettings) {
										<mat-form-field subscriptSizing="dynamic" appearance="outline" class="form-field-input-no-margin">
											<input
												matInput
												#input
												[formControl]="ajaxHubIdFormControl"
												data-automation-id="ajax-hub-id-input"
											/>
											@if (this.ajaxHubIdFormControl.hasError('limitedAlphanumeric')) {
												<mat-error
													class="row-left"
													data-automation-id="ajax-hub-id-code-error"
													i18n="@@deviceAbout-errorMessageLettersAndNumbers"
												>
													Letters (A-F) and numbers only.
												</mat-error>
											}
										</mat-form-field>
									}
									@if (!isEditingSettings) {
										<ng-container class="column center-elements-vertically">
											<p>
												{{
													isInvalidString(this.deviceSettingsKV.ajaxHubId) ? '- - -' : this.deviceSettingsKV.ajaxHubId
												}}
											</p>
										</ng-container>
									}
								</div>
							</div>
						}
					</div>
				}
			</div>
		}
	</div>
</div>
